<script setup lang="ts">
import { FormRow, FormSection } from '@it-tools/shell'
import { useI18n } from 'vue-i18n'
import { PRICES, PROVIDER_IDS, type ProviderId } from '../model/priceBook'
import { isValidDiscount, type Spec } from '../model/spec'
import NumberField from './NumberField.vue'

const props = defineProps<{ modelValue: Spec['discounts'] }>()
const emit = defineEmits<{ 'update:modelValue': [Spec['discounts']] }>()

const { t } = useI18n()

function update(provider: ProviderId, percent: number): void {
  emit('update:modelValue', { ...props.modelValue, [provider]: percent })
}
</script>

<template>
  <FormSection :legend="t('form.discounts')">
    <p class="discounts__hint">{{ t('form.discountsHint') }}</p>
    <FormRow
      v-for="provider in PROVIDER_IDS"
      :key="provider"
      :label="PRICES.providers[provider].name"
      :for-id="`discount-${provider}`"
    >
      <NumberField
        :id="`discount-${provider}`"
        :model-value="modelValue[provider]"
        :unit="t('form.percentOff')"
        :valid="isValidDiscount"
        :error="t('form.discountInvalid')"
        step="any"
        :label="t('form.discount', { provider: PRICES.providers[provider].name })"
        @update:model-value="(percent) => update(provider, percent)"
      />
    </FormRow>
  </FormSection>
</template>

<style scoped>
.discounts__hint {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
</style>
